/* eslint-disable no-underscore-dangle */
let pendingMissionId: string | null = null;
let pendingLaunchExpiresAt = 0;
const PENDING_LAUNCH_TTL_MS = 2 * 60 * 1000;

const normalizeMissionId = (missionId: unknown): string | null => {
  if (!missionId) return null;
  if (typeof missionId === 'string') return missionId;
  if (typeof missionId === 'object' && '_id' in missionId) {
    return normalizeMissionId((missionId as { _id?: unknown })._id);
  }
  return String(missionId);
};

// Module state is intentionally tab-local. This prevents another open tab for
// the same PIC from reacting to a launch broadcast that this tab did not start.
export const setPendingLaunch = (missionId: unknown) => {
  pendingMissionId = normalizeMissionId(missionId);
  pendingLaunchExpiresAt = Date.now() + PENDING_LAUNCH_TTL_MS;
};

export const clearPendingLaunch = () => {
  pendingMissionId = null;
  pendingLaunchExpiresAt = 0;
};

export const isPendingLaunch = (missionId: unknown) => {
  if (pendingLaunchExpiresAt < Date.now()) clearPendingLaunch();
  const normalizedMissionId = normalizeMissionId(missionId);
  return !!pendingMissionId && pendingMissionId === normalizedMissionId;
};

export const getMissionIdFromLaunchPrompt = (prompt: any) =>
  normalizeMissionId(
    prompt?.mission?._id ??
      prompt?.mission ??
      prompt?.queuedMission?.mission?._id ??
      prompt?.queuedMission?.mission
  );
